import { Injectable, forwardRef } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useClass: forwardRef(() => DefaultLoadingService),
})
export abstract class LoadingService {
  abstract isLoading: Observable<boolean>;
  abstract mode: string;

  abstract setLoading(loading: boolean): void;
}

@Injectable({ providedIn: 'root' })
export class DefaultLoadingService implements LoadingService {
  private loading = new BehaviorSubject(false);
  isLoading: Observable<boolean> = this.loading.pipe(distinctUntilChanged());
  readonly mode = 'spinner';

  setLoading(loading: boolean): void {
    this.loading.next(loading);
  }
}
